// extracted by mini-css-extract-plugin
export default {"button":"TrashButton_button__c32Wp"};